import { createBrowserRouter } from 'react-router-dom';
import { Suspense } from 'react';
import RedirectHandler from './RedirectHandler';
import {
  HomePage,
  // QuestionsPage,
  // MatchTherapistHome,
  ErrorBoundaryRoutes,
  QuestionsPage,
  BaseBotHandler,
  BaseUseCaseHandler,
  MatchATherapistHome,
} from './routeConfig';
import { ERoutePaths } from '@/types';

const router = createBrowserRouter([
  {
    path: '/redirect',
    element: <RedirectHandler />,
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="An error occurred while redirecting" />
      </Suspense>
    ),
  },
  {
    path: '/',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <HomePage /> {/* Regular home page */}
          </Suspense>
        ),
      },
      {
        path: 'questions',
        element: (
          <Suspense fallback={null}>
            <QuestionsPage />
          </Suspense>
        ),
      },
    ],
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="Something went wrong" />
      </Suspense>
    ),
  },
  {
    /**
     * Standalone therapist flow. Declared explicitly rather than resolved
     * through `/:botName` because it has its own landing screen — React Router
     * ranks this static segment above the dynamic one, so it always wins. The
     * questions screen is the shared one.
     */
    path: `/${ERoutePaths.MATCH_THERAPIST_V2}`,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <MatchATherapistHome />
          </Suspense>
        ),
      },
      {
        path: ERoutePaths.QUESTIONS,
        element: (
          <Suspense fallback={null}>
            <QuestionsPage />
          </Suspense>
        ),
      },
    ],
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="Something went wrong" />
      </Suspense>
    ),
  },
  {
    path: '/:botName',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={null}>
            <BaseBotHandler />
          </Suspense>
        ),
      },

      {
        path: 'questions',
        element: (
          <Suspense fallback={null}>
            <QuestionsPage />
          </Suspense>
        ),
      },
      {
        path: ':useCase',
        children: [
          {
            index: true,
            element: (
              // <Suspense fallback={null}>
              <BaseUseCaseHandler />
              // </Suspense>
            ),
          },
          {
            path: 'questions',
            element: (
              // <Suspense fallback={null}>
              <QuestionsPage />
              // </Suspense>
            ),
          },
        ],
        errorElement: (
          // <Suspense fallback={null}>
          <ErrorBoundaryRoutes message="Something went wrong" />
          // </Suspense>
        ),
      },
    ],
    errorElement: (
      <Suspense fallback={null}>
        <ErrorBoundaryRoutes message="Something went wrong" />
      </Suspense>
    ),
  },
]);

export { router };
